import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const accountsApi = createApi({
  reducerPath: 'accountsApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['accounts'],
  endpoints: (builder) => ({
    findAccountDetailByServiceProvider: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.accountDetailController.findAccountDetailByServiceProvider}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getAllAccountDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.accountDetailController.getAllAccountDetail,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.reqData,
        };
      },
    }),
    saveAccountDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.accountDetailController.saveAccountDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.reqData,
        };
      },
    }),
    updateAccountDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.accountDetailController.updateAccountDetail,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.reqData,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAccountDetailByServiceProviderMutation,
  useGetAllAccountDetailMutation,
  useSaveAccountDetailMutation,
  useUpdateAccountDetailMutation,
} = accountsApi;
